import { api, apiWithoutContentType } from './client';

// New Product Approval (coach / medical incharge -> purchase manager -> admin)

export const createProductApproval = async (formData) => {
  const response = await apiWithoutContentType.post('/api/v2/product-approvals', formData);
  return response.data;
};

export const getProductApprovals = async (params = {}) => {
  const response = await api.get('/api/v2/product-approvals', { params });
  return response.data;
};

export const approveProductApproval = async (id, data = {}) => {
  const response = await api.post(`/api/v2/product-approvals/${id}/approve`, data);
  return response.data;
};

export const rejectProductApproval = async (id, notes = '') => {
  const response = await api.post(`/api/v2/product-approvals/${id}/reject`, { notes });
  return response.data;
};

export const getProductApprovalAttachment = async (id, attachmentId) => {
  const response = await api.get(`/api/v2/product-approvals/${id}/attachments/${attachmentId}`, {
    responseType: 'blob',
  });
  return response.data;
};

export const getVendorOptions = async () => {
  const response = await api.get('/api/v2/vendors', { params: { active: true, limit: 100 } });
  return response.data;
};
